import React from "react";
import { connect } from "react-redux";
import { Modal, Form } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import DynamicFilter from "../../components/frame/DynamicFilter";
import ReactAbstract from "../../components/abstract/React.abstract";
import {
	fetchEmployeesList
} from '../../actions/employee-management-actions';
import {
	fetchDepartmentsList
} from '../../actions/department-structure-actions';
import {
	changeInsuranceLedger,
	selectInsuranceLedger,
	// updateInsuranceLedger,
} from "../../actions/salary-allowance-actions";
import insuranceLedgerService from "../../services/SalaryAllowance/insurance-ledger-service";


class InsuranceLedgerDetail extends ReactAbstract {

	dataMode = 1
	deleteRowSelection = true
	childModuleName = "insuranceLedger"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {
			modelId: this.props.routing.location.pathname.split('/')[3]
		},
		data: [],
		dataStatus: "unload",
	}

	actions = {
		selectAction: insuranceLedgerService.detailInsuranceLedger,
		exportAction: insuranceLedgerService.exportInsuranceLedger,
	}

	headerColumn = [
		// {
		// 	title: "保险计算",
		// 	icon: "plus-circle-o",
		// 	click: () => {}
		// }, 
		{
			title: "导出",
			icon: "cloud-download-o",
			click: this.publicExport
		}
	]

	filterColumn = [{
			type: "person"
		}, {
			type: "department"
		}
	]

	tableColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-small'
		},{
			title: '中文名',
			dataIndex: 'employee_name',
			key: 'employee_name',
			className: 'table-global-head-small'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '国籍',
			dataIndex: 'nationality_name',
			key: 'nationality_name',
			className: 'table-global-head-small'
		}, {
			title: '地区',
			dataIndex: 'area',
			key: 'area',
			className: 'table-global-head'
		}, {
			title: '险种',
			dataIndex: 'insurance_type_str',
			key: 'insurance_type_str',
			className: 'table-global-head-small'
		}, {
			title: '社保基数',
			dataIndex: 'social_insurance_base',
			key: 'social_insurance_base',
			className: 'table-global-head-short'
		}, {
			title: '年份',
			dataIndex: 'insured_year',
			key: 'insured_year',
			className: 'table-global-head-tiny'
		}, {
			title: '月份',
			dataIndex: 'account_monthly',
			key: 'account_monthly',
			className: 'table-global-head-tiny'
		},{
			title: '实际缴费月份',
			dataIndex: 'insured_actual_month',
			key: 'insured_actual_month',
			className: 'table-global-head-large'
		}, {
			title: '个人养老费',
			dataIndex: 'pension_rates_personal',
			key: 'pension_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人医疗费',
			dataIndex: 'medical_rates_personal',
			key: 'medical_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人失业费',
			dataIndex: 'unemployment_rates_personal',
			key: 'unemployment_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人公积金',
			dataIndex: 'provident_fund_rates_personal',
			key: 'provident_fund_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '单位养老费',
			dataIndex: 'pension_rates_unit',
			key: 'pension_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位医疗费',
			dataIndex: 'medical_rates_unit',
			key: 'medical_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位失业费',
			dataIndex: 'unemployment_rates_unit',
			key: 'unemployment_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位工伤费',
			dataIndex: 'work_injury_rates_unit',
			key: 'work_injury_rates_unit',
			className: 'table-global-head-6x'
		},{
			title: '单位生育费',
			dataIndex: 'fertility_rates_unit',
			key: 'fertility_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位公积金',
			dataIndex: 'provident_fund_rates_unit',
			key: 'provident_fund_rates_unit',
			className: 'table-global-head-6x'
		}
	]

	formColumn = () => [{
			label: "员工姓名",
			key: "employee_name",
			type: "text"
		}, {
			label: "部门名称",
			key: "department_name",
			type: "text"
		}, {
			label: "基本工资",
			key: "current_base_salary",
			type: "text"
		}, {
			label: "岗位工资",
			key: "current_post_salary",
			type: "text"
		}, {
			label: "",
			type: "title"
		}, {
			label: "事假扣款",
			key: "leave_subsidies",
			type: "number",
			required: false
		}, {
			label: "病假扣款",
			key: "sick_leave_subsidies",
			type: "number",
			required: false
		}, {
			label: "其他假期",
			key: "other_holidays",
			type: "number",
			required: false
		}, {
			label: "未打卡扣款",
			key: "not_punched_deduct",
			type: "number",
			required: false
		}, {
			label: "迟到扣款",
			key: "come_late_deduct",
			type: "number",
			required: false
		}, {
			label: "旷工扣款",
			key: "stay_away_deduct",
			type: "number",
			required: false
		}, {
			label: "课时费",
			key: "class_hour_fee",
			type: "number",
			required: false
		}, {
			label: "津贴",
			key: "allowance",
			type: "number",
			required: false
		}, {
			label: "补贴",
			key: "subsidy",
			type: "number",
			required: false
		},
		//  {
		// 	label: "发票抵税",
		// 	key: "invoice_tax_deduct",
		// 	type: "number",
		// 	required: false
		// },
		 {
			label: "税后扣款",
			key: "post_tax_deduct",
			type: "number",
			required: false
		}, {
			label: "现金",
			key: "cash",
			type: "number",
			required: false
		}, {
			label: "劳保健",
			key: "laobaojian",
			type: "number",
			required: false
		}
	]

	customComponentWillMount () {
		this.props.fetchDepartmentsList();
		// setInterval(() => {console.log(this.state)}, 3000)
	}

	updateData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index
	})

	render () {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />
					<DynamicFilter column={this.filterColumn}
						departmentsList={this.props.departmentStructure.departmentsList}
						value={this.state.filters}
						setFilter={this.publicChange} />
				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="薪资台账"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<DynamicForm column={this.formColumn}
						form={this.props.form}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
		employeeManagement: state.employeeManagement,
		departmentStructure: state.departmentStructure,
		routing: state.routing
	}
}

const mapDispatchToProps = {
	fetchEmployeesList,
	fetchDepartmentsList,
	changeInsuranceLedger,
	selectInsuranceLedger,
}

InsuranceLedgerDetail = Form.create()(InsuranceLedgerDetail);

InsuranceLedgerDetail = connect(mapStateToProps, mapDispatchToProps)(InsuranceLedgerDetail);

export default LayoutWrapper(InsuranceLedgerDetail);





// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/InsuranceLedgerDetail.js